import classNames from "classnames";
import { FC, PropsWithChildren } from "react";
import styles from "./Card.module.css";

type CardProps = PropsWithChildren<{
  className?: string;
}>;

const Card: FC<CardProps> = ({ children, className }: CardProps) => (
  <section className={classNames(styles.card, className)}>{children}</section>
);

export default Card;
